
import { Component, Vue } from 'vue-property-decorator'
import AppButton from '@/components/AppButton.vue'
import { ChildComponentMixin } from '@/mixins'

@Component({
    components: {
        AppButton,
    },
})
export default class IntegrationsHeader extends ChildComponentMixin {
    private addIntegrationClick() {
        this.$router.push('/integrations/new')
    }
}
